'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
var _Error = require('../../../node_modules/@material-ui/icons/Error.js');
var Button = require('../../Inputs/Buttons/Button/Button.js');
var makeStyles = require('../../Styles/makeStyles.js');
var Snackbar$1 = require('../../../node_modules/@material-ui/core/esm/Snackbar/Snackbar.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return {
    root: {},
    error: {
      backgroundColor: theme.palette.error.main
    },
    button: {
      color: theme.palette.common.white
    },
    icon: {
      opacity: 0.9,
      marginRight: theme.spacing(1)
    },
    message: {
      display: 'flex',
      alignItems: 'center'
    }
  };
});

var Snackbar = function Snackbar(_ref) {
  var message = _ref.message,
      actionMessage = _ref.actionMessage,
      onClick = _ref.onClick,
      variant = _ref.variant,
      buttonProps = _ref.buttonProps,
      restOfProps = objectWithoutProperties(_ref, ["message", "actionMessage", "onClick", "variant", "buttonProps"]);

  var classes = useStyles();

  var _ref2 = buttonProps || {},
      _ref2$classes = _ref2.classes,
      buttonPropsClasses = _ref2$classes === void 0 ? {} : _ref2$classes;

  buttonPropsClasses = _objectSpread({}, buttonPropsClasses, {
    root: classNames__default["default"](classes.button, buttonPropsClasses.root)
  });
  return React__default["default"].createElement(Snackbar$1["default"], _objectSpread({
    ContentProps: {
      classes: {
        root: classNames__default["default"](defineProperty({}, classes.error, variant === 'error'))
      },
      message: React__default["default"].createElement("span", {
        className: classes.message
      }, variant === 'error' && React__default["default"].createElement(_Error, {
        className: classNames__default["default"](classes.icon)
      }), message),
      action: actionMessage && React__default["default"].createElement(Button["default"], _objectSpread({
        onClick: onClick
      }, buttonProps, {
        classes: buttonPropsClasses
      }), actionMessage)
    }
  }, restOfProps));
};

Snackbar.defaultProps = {
  message: '',
  onClick: function onClick() {},
  variant: '',
  actionMessage: '',
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  autoHideDuration: 6000,
  open: false
};

module.exports = Snackbar;
